var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbtack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 455.998C160 457.248 160.281 458.467 160.844 459.576L184.844 507.576C187.781 513.467 196.219 513.482 199.156 507.576L223.156 459.576C223.625 458.654 224 457.045 224 455.998V383.998H160V455.998ZM298.031 214.266L285.781 96H328C341.25 96 352 85.25 352 72V24C352 10.75 341.25 0 328 0H56C42.75 0 32 10.75 32 24V72C32 85.25 42.75 96 56 96H98.219L85.969 214.266C37.469 236.812 0 277.266 0 328C0 341.25 10.75 352 24 352H360C373.25 352 384 341.25 384 328C384 276.812 346.031 236.578 298.031 214.266Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbtack);
export default __webpack_public_path__ + "static/media/thumbtack.3ab848c3d0eb55528588d5d8dc0682f3.svg";
export { ForwardRef as ReactComponent };